import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import React from 'react';
import styled from 'styled-components';

import { IconArrowRight } from '../../easyclaim.app.assets/index';

interface MenuProps {
	isOpen: boolean;
	close: () => void;
	closeOnBackdropClick?: boolean;
	header?: React.ReactNode;
	children?: React.ReactChild;
}

export class Menu extends React.Component<MenuProps, {}> {
	body?: HTMLDivElement | null;

	constructor(props: MenuProps) {
		super(props);
	}

	componentWillReceiveProps(newProps: MenuProps) {
		if (!this.props.isOpen && newProps.isOpen && this.body) {
			disableBodyScroll(this.body);
		} else if (this.props.isOpen && !newProps.isOpen && this.body) {
			enableBodyScroll(this.body);
		}
	}

	componentWillUnmount() {
		clearAllBodyScrollLocks();
	}

	onBackdropClicked = () => {
		if (this.props.closeOnBackdropClick) {
			this.props.close();
		}
	};

	render() {
		return (
			<>
				<MenuContainer isOpen={this.props.isOpen}>
					<ContentContainer isOpen={this.props.isOpen}>
						<StyledArrowRight onClick={this.props.close} />
						{this.props.header && <Header>{this.props.header}</Header>}
						{this.props.children && <Body ref={(r) => (this.body = r)}>{this.props.children}</Body>}
					</ContentContainer>
				</MenuContainer>
				<Backdrop isOpen={this.props.isOpen} onClick={this.onBackdropClicked} />
			</>
		);
	}
}

const MenuContainer = styled.div<{ isOpen: boolean }>`
	position: fixed;
	top: 0;
	right: 0;
	height: 100vh;
	z-index: 2000;
	visibility: ${(p) => (p.isOpen ? 'visible' : 'hidden')};
	backface-visibility: hidden;
	@media (orientation: portrait) {
		width: 80vw;
		max-width: 630px;
		min-width: 280px;
	}
	@media (orientation: landscape) {
		width: 30vw;
		max-width: 630px;
		min-width: 280px;
	}
`;

const ContentContainer = styled.div<{ isOpen: boolean }>`
	padding: 2rem 0rem;
	height: 100vh;
	box-sizing: border-box;
	color: #000;
	background-color: #fff;
	box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 5px;
	position: relative;
	margin: 0 auto;
	visibility: ${(p) => (p.isOpen ? 'visible' : 'hidden')};
	transform: ${(p) => (p.isOpen ? 'translateX(0%);' : 'translateX(100%)')};
	transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
	display: flex;
	flex-direction: column;
`;

const StyledArrowRight = styled(IconArrowRight)`
	height: 3rem;
	color: #fff;
	position: absolute;
	top: 0rem;
	left: -4rem;
	padding: 1rem;
	transition:
		color 0.1s,
		transform 0.1s;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	&:hover {
		color: lighten(0.1, ${(p) => p.theme.colors.primary});
	}
	&:active {
		color: lighten(0.1, ${(p) => p.theme.colors.primary});
		transform: scale(0.8);
	}
`;

const Header = styled.div`
	padding: 0rem 0 2rem 0;
	margin: 0 auto;
	flex-shrink: 0;
	flex-grow: 0;
`;

const Body = styled.div`
	padding: 0rem 2rem 0rem 2rem;
	overflow-y: auto;
	flex-shrink: 1;
	flex-grow: 1;
`;

const Backdrop = styled.div<{ isOpen: boolean }>`
	position: fixed;
	width: 100%;
	height: 100%;
	visibility: ${(p) => (p.isOpen ? 'visible' : 'hidden')};
	top: 0;
	left: 0;
	z-index: 1000;
	opacity: ${(p) => (p.isOpen ? '1' : '0')};
	background: rgba(0, 0, 0, 0.4);
	transition: all 0.3s;
	overflow: hidden;
`;
